import { Navigate, useParams } from 'react-router-dom';
import { NEW_WORKSITE_HREF, editWorksiteHref } from './worksiteDialogHref.js';

/**
 * THE TWO RETIRED WORKSITE FORM ADDRESSES, KEPT ALIVE.
 *
 * `/worksites/new` and `/worksites/:id/edit` were pages until create and edit
 * became a sheet over the list. Bookmarks, emailed links and the user manual
 * still name them, so each lands on the list with the matching sheet open
 * rather than on a 404. `replace`, so Back does not bounce through the old
 * address.
 *
 * A REDIRECT, NOT A PAGE, and the route guards know it by this name
 * (`navigationWiring.test.ts`, `routeGates.test.tsx`): it renders nothing of
 * its own, so the gate that matters is the destination's, and no in-app link
 * may point at it.
 */
export function WorksiteDialogRedirect(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? editWorksiteHref(id) : NEW_WORKSITE_HREF} replace />;
}
